import { combineReducers } from 'redux-immutable';
import { fromJS } from 'immutable';

import { actionTypes } from 'modules/reports/constants/externalCollection';

const initStateExternalCollectionReportReducer = fromJS({
  exportExternalCollectionReportLoading: false,
  exportExternalCollectionReportResult: null,
});

function externalCollectionReportReducer(state = initStateExternalCollectionReportReducer, action) {
  switch (action.type) {
    case actionTypes.EXPORT_EXTERNAL_COLLECTION_REPORT_LOADING:
      return state.set('exportExternalCollectionReportLoading', fromJS(action.payload));
    case actionTypes.EXPORT_EXTERNAL_COLLECTION_REPORT:
      return state.set('exportExternalCollectionReportResult', fromJS(action.payload));
    case actionTypes.RESET_EXTERNAL_COLLECTION_EXPORT_SUCCESS:
      return state.set('exportExternalCollectionReportResult', fromJS(null));
    default:
      return state;
  }
}

const initStateExternalCollectionItemReportReducer = fromJS({
  exportExternalCollectionItemLoading: false,
  exportExternalCollectionItemResult: null,
});

function externalCollectionItemReportReducer(
  state = initStateExternalCollectionItemReportReducer,
  action,
) {
  switch (action.type) {
    case actionTypes.EXPORT_EXTERNAL_COLLECTION_ITEM_REPORT_LOADING:
      return state.set('exportExternalCollectionItemLoading', fromJS(action.payload));
    case actionTypes.EXPORT_EXTERNAL_COLLECTION_ITEM_REPORT:
      return state.set('exportExternalCollectionItemResult', fromJS(action.payload));
    case actionTypes.RESET_EXTERNAL_COLLECTION_ITEM_EXPORT_SUCCESS:
      return state.set('exportExternalCollectionItemResult', fromJS(null));
    default:
      return state;
  }
}

export default combineReducers({
  externalCollectionReport: externalCollectionReportReducer,
  externalCollectionItemReport: externalCollectionItemReportReducer,
});
